import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "container-full-5" }
const _hoisted_2 = {
  key: 0,
  class: "flex-center py-7"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "secondary-font text-center mt-6 mb-5" }
const _hoisted_5 = { class: "s20 bg-grey-25 border-grey p-4 rounded-50 mt-5 px-7 py-7" }
const _hoisted_6 = { class: "s10 secondary-font mb-4 px-5" }
const _hoisted_7 = { class: "s10 secondary-font mb-4 px-5" }
const _hoisted_8 = { class: "s10 secondary-font mb-4 px-5" }
const _hoisted_9 = { class: "s10 secondary-font mb-4 px-5" }
const _hoisted_10 = {
  key: 2,
  class: "text-center py-7"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[13] || (_cache[13] = _createElementVNode("h2", { class: "secondary-font gap-4 mt-2 mb-6 text-center" }, "Transaction", -1)),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[1] || (_cache[1] = [
          _createElementVNode("p", { class: "secondary-font text-grey-600" }, "Chargement...", -1)
        ]))]))
      : (_ctx.transaction)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _cache[10] || (_cache[10] = _createElementVNode("div", {
              class: "rounded-200 px-7 py-7 text-center",
              style: {"background-color":"rgba(0, 185, 172, 0.08)","width":"8.5rem","height":"8.5rem","margin":"auto","display":"flex","align-items":"center","justify-content":"center"}
            }, [
              _createElementVNode("img", {
                src: "/public/icons/icon-trans-recharger.svg",
                width: "100%",
                class: "icon-neutral",
                alt: ""
              })
            ], -1)),
            _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.transaction.libelle), 1),
            _createElementVNode("h1", {
              class: _normalizeClass(["secondary-font text-center", _ctx.transaction.type === 'credit' ? 'text-green' : ''])
            }, _toDisplayString(_ctx.transaction.type === 'credit' ? '+' : '-') + _toDisplayString(_ctx.formatAmount(_ctx.transaction.montant)) + " F ", 3),
            _createElementVNode("div", _hoisted_5, [
              _cache[3] || (_cache[3] = _createElementVNode("h6", { class: "s10 secondary-font font-normal text-right mb-4 px-5" }, "Date d'opération", -1)),
              _createElementVNode("h6", _hoisted_6, _toDisplayString(_ctx.formatDateDetail(_ctx.transaction.date)), 1),
              _cache[4] || (_cache[4] = _createElementVNode("h6", { class: "s10 secondary-font font-normal text-right mb-4 px-5" }, "Montant", -1)),
              _createElementVNode("h6", _hoisted_7, _toDisplayString(_ctx.formatAmount(_ctx.transaction.montant)) + " F", 1),
              _cache[5] || (_cache[5] = _createElementVNode("h6", { class: "s10 secondary-font font-normal text-right mb-4 px-5" }, "Catégorie", -1)),
              _createElementVNode("h6", _hoisted_8, _toDisplayString(_ctx.categorieLabel(_ctx.transaction.categorieSlug)), 1),
              _cache[6] || (_cache[6] = _createElementVNode("h6", { class: "s10 secondary-font font-normal text-right mb-4 px-5" }, "Statut", -1)),
              _cache[7] || (_cache[7] = _createElementVNode("h6", { class: "s10 secondary-font mb-4 px-5" }, [
                _createElementVNode("span", { class: "tag-state success" }, "Effectuée")
              ], -1)),
              _cache[8] || (_cache[8] = _createElementVNode("h6", { class: "s10 secondary-font font-normal text-right mb-4 px-5" }, "Id de transaction", -1)),
              _createElementVNode("h6", _hoisted_9, _toDisplayString(_ctx.transaction.reference), 1),
              _cache[9] || (_cache[9] = _createElementVNode("div", { class: "clear-both h-1" }, null, -1)),
              _createElementVNode("button", {
                class: "btn black mt-4 margin-auto",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.shareTransaction && _ctx.shareTransaction(...args)))
              }, [...(_cache[2] || (_cache[2] = [
                _createElementVNode("img", {
                  src: "/public/icons/icon-share.svg",
                  class: "size-sm icon-white mr-2",
                  alt: ""
                }, null, -1),
                _createElementVNode("span", null, "Partager", -1)
              ]))])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _cache[12] || (_cache[12] = _createElementVNode("p", { class: "secondary-font text-grey-600" }, "Transaction introuvable", -1)),
            _createVNode(_component_router_link, {
              to: "/front/wallet",
              class: "btn sm light mt-4"
            }, {
              default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                _createTextVNode("Retour au wallet", -1)
              ]))]),
              _: 1
            })
          ])),
    _cache[14] || (_cache[14] = _createElementVNode("div", { class: "clear-both h-60" }, null, -1))
  ]))
}